
<!--
 * @Description:布置作业
 * @Author: 王丽欣
 * @Date: 2023-03-01 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:23:57
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w900 h600" :model-value="openBuZhiZuoYe" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">布置作业详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openBuZhiZuoYe', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{row.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="课程" label-align="right" align="left" width="120px" span="2">{{row.kcmc}}</el-descriptions-item>
        <el-descriptions-item label="周次" label-align="right" align="left" width="120px" span="2"><span v-if="row.zc">第{{row.zc}}周</span></el-descriptions-item>
        <el-descriptions-item label="班级/节次" label-align="right" align="left" width="120px" span="2"><span>{{row.bjmc}} / 星期{{week[row.xq]}} 第{{row.jc}}节</span></el-descriptions-item>
        <el-descriptions-item label="教学单元" label-align="right" align="left" width="120px" span="2">{{ruleForm.jxdybt}}</el-descriptions-item>
        <el-descriptions-item label="教学内容" label-align="right" align="left" width="120px" span="2">{{ruleForm.jxnrbt}}</el-descriptions-item>
        <el-descriptions-item label="作业" label-align="right" align="left" width="120px" span="2">{{ruleForm.zuoyemingc}}</el-descriptions-item>
        <el-descriptions-item label="作业类型" label-align="right" align="left" width="120px" span="2">{{ruleForm.zylxmc}}</el-descriptions-item>
        <el-descriptions-item label="截止时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.jzsj}}</el-descriptions-item>
        <el-descriptions-item label="计入平时成绩" label-align="right" align="left" width="120px" span="2">
          <span v-if="ruleForm.sfjrpscj === true">是</span>
          <span v-if="ruleForm.sfjrpscj === false">否</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <span>
          <el-button @click="handleClose">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  closeWindow,
  actionPost
} from '@/api/common.js'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import zuoyedantiao from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/zuoyedantiao.vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'

const props = defineProps({
  openBuZhiZuoYe: {
    type: Boolean,
    required: true
  },
  zuoyeobj: {
    type: Object,
    required: false
  },
  row: {
    type: Object,
    required: false
  },
  chechboxtrue: {
    type: Array,
    required: false
  }
})
const emits = defineEmits(['update:openBuZhiZuoYe', 'ReturnData'])
const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
const ruleFormRef = ref(null)
const ruleForm = ref({})


// 关闭
const handleClose = () => {
  emits('update:openBuZhiZuoYe', false)
}
const row = ref()
const initInfo = () => {
  actionPost({
    url: '/api/v2/ziyuanku/xueshengzuoye/dangqianjiaoshibuzhizouye',
    data: { bjid: row.value.bjid, kcid: row.value.kcid, xqid: row.value.xqid, zc: row.value.zc, xq: row.value.xq, jc: row.value.jc }
  }).then((res) => {
    if (res.code === 200) {
      ruleForm.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openBuZhiZuoYe,
  () => {
    if (props.openBuZhiZuoYe) {
      actionPost({
        url: '/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoshijiaoxueshejikejian/' + props.row.id,
        data: {}
      }).then((res) => {
        if (res.code === 200) {
          row.value = res.data
          initInfo()
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
